import React,{useEffect, useRef} from 'react'

import { useState } from 'react'

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';


import { Print } from '@mui/icons-material';
import LedgerForm from '../components/LedgerForm';
import { useAppData } from '../../../../../../context/AppDataContext';
import FinanceLayout from '../../../../../../layout/components/FinanceLayout';
import { Link } from 'react-router-dom';



const CellActions = (props) =>{
    return(
        <>
            {/* <LedgerForm  callBack={props.callBack} data={props.data} /> */}
            <Link to={"/ledger-details/"+props.data.id} >{props.data.title}</Link>
            {/*<ConfirmDialog id={props.data.id} confirm={ ()=>props.remove(props.data.id)} >Are you Sure You want to remove</ConfirmDialog> */}
        </>
    )
  }


function LedgerListPage() {

  
  const {ledgerGroupDD, ledgerList,getLedgerList, getDDDataById,} = useAppData();
  const gridRef = useRef();
  

  const remove = () =>{

  }

  const [defaultColDef] = useState({
    floatingFilter: true,
    filterParams: {
      buttons: ['apply'],
    },
    resizable: true,
    width:120,
    filter:true,
    sortable: true,
    cellStyle: { 'textTransform': 'uppercase' },
  });


  const [columnDefs,setColumnDef] = useState();
    const prepairColumnDef = () => {
    let _columnDefs = [
        {field:"id",headerName: "ID"},
        
        {headerName:"Ledger Name", width:"200", valueGetter: params => params.data.title,
            cellRenderer: CellActions,
            cellRendererParams: {
                callBack:getLedgerList,
                remove:remove
            },
        },

        {field:"groupId",headerName: "Ledger Group",width:250,  valueGetter: params => getDDDataById(ledgerGroupDD, params.data.groupId)?.label},
             
    ];
    setColumnDef(_columnDefs);
  }

  const onBtnExport = () => {
    gridRef.current.api.exportDataAsCsv("data.csv");
  };

  useEffect(()=>{    
    prepairColumnDef();
  },[]);
  return (
    <FinanceLayout>
      <div className='row'>
        <div className='col-md-6'><h4>Ledgers</h4></div>
        <div className='col-md-6'> 
          <span className='float-end'><LedgerForm callBack={getLedgerList} /></span>
          <button className='btn btn-warning me-2 float-end' onClick={onBtnExport} ><Print /> Export </button>
        </div>
        <div className='col-md-12 mt-2'>
          <div className="ag-theme-alpine" style={{height: 650}}>
              <AgGridReact
                ref={gridRef}
                rowData={ledgerList}
                columnDefs={columnDefs}
                defaultColDef={defaultColDef}
                animateRows={true}
                onGridReady={getLedgerList}
              />
            </div>
          </div>
        </div>
    </FinanceLayout>
    
  )
}

export default LedgerListPage